import { Link } from '@tanstack/react-router';
import type { ComponentPropsWithoutRef } from 'react';
import type { UpgradeTarget } from '@/lib/upgrade-link';

type UpgradeLinkProps = Omit<ComponentPropsWithoutRef<'a'>, 'href'> &
  Omit<UpgradeTarget, 'source'> & {
    /** Analytics: the surface the link is on. */
    source: string;
  };

/** A link into the upgrade wizard, on `plan` when given. */
export function UpgradeLink({ plan, source, ...props }: UpgradeLinkProps) {
  return (
    <Link
      to='/upgrade'
      search={{ ...(plan ? { plan } : {}), source }}
      {...props}
    />
  );
}
